<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
  <footer class="bg-console-panel border-t border-console-border mt-auto">
    <div class="max-w-7xl mx-auto px-4 py-8">
      <!-- Main Footer Content -->
      <div class="grid md:grid-cols-4 gap-8 mb-8">
        <!-- Brand -->
        <div class="md:col-span-2">
          <div class="flex items-center gap-2 mb-3">
            <span class="text-2xl">🎬</span>
            <span class="text-xl font-bold text-white">Tamil Soundboard</span>
          </div>
          <p class="text-slate-400 text-sm mb-4">
            The ultimate collection of Tamil movie dialogues, memes, and sound effects. 
            Play and share your favorite clips instantly!
          </p>
          <div class="flex gap-3">
            <a 
              href="https://twitter.com/tamilsoundboard" 
              target="_blank"
              class="w-8 h-8 bg-console-bg rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:bg-slate-700 transition-colors"
              title="Twitter/X"
            >
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a 
              href="https://instagram.com/tamilsoundboard" 
              target="_blank"
              class="w-8 h-8 bg-console-bg rounded-lg flex items-center justify-center text-slate-400 hover:text-white hover:bg-slate-700 transition-colors"
              title="Instagram"
            >
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div>
          <h3 class="text-white font-semibold mb-3">Quick Links</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/" class="text-slate-400 hover:text-primary text-sm transition-colors">
                Home
              </router-link>
            </li>
            <li>
              <router-link to="/about" class="text-slate-400 hover:text-primary text-sm transition-colors">
                About Us
              </router-link>
            </li>
            <li>
              <router-link to="/contact" class="text-slate-400 hover:text-primary text-sm transition-colors">
                Contact
              </router-link>
            </li>
            <li>
              <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLSdxxxxxxxxxx/viewform" 
                target="_blank"
                class="text-slate-400 hover:text-primary text-sm transition-colors"
              >
                Request a Clip
              </a>
            </li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h3 class="text-white font-semibold mb-3">Legal</h3>
          <ul class="space-y-2">
            <li>
              <router-link to="/privacy" class="text-slate-400 hover:text-primary text-sm transition-colors">
                Privacy Policy
              </router-link>
            </li>
            <li>
              <router-link to="/terms" class="text-slate-400 hover:text-primary text-sm transition-colors">
                Terms of Service
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- Copyright -->
      <div class="border-t border-console-border pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <p class="text-slate-500 text-sm">
          © {{ currentYear }} Tamil Soundboard. All rights reserved.
        </p>
        <p class="text-slate-600 text-xs">
          Audio clips are property of their respective copyright holders.
        </p>
      </div>
    </div>
  </footer>
</template>
